import React, { useState } from "react";
import { ProfileCard, VilleDrawer } from "@viewComponents/profile_utils";

interface Ville {
  id: number;
  name: string;
  inhabitants?: number;
  chalandise?: number;
  point_of_sales_count?: number;
  installation_aids_count?: number;
  address?: {
    postal_code: string;
    locality: string;
    formatted_address: string;
    latitude: number;
    longitude: number;
    administrative_area_level_1?: string | null;
    country: string;
  } | null;
}

interface SearchVillesProps {
  count: number;
  villes?: Ville[];
  message?: string;
}

export const SearchVillesResult: React.FC<SearchVillesProps> = ({
  count,
  villes = [],
  message,
}) => {
  const [selectedVille, setSelectedVille] = useState<Ville | null>(null);

  if (count === 0 || message) {
    return (
      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
        {message || "Aucune ville trouvée"}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium text-gray-700">
        {count} ville{count > 1 ? "s" : ""} trouvée{count > 1 ? "s" : ""}
      </div>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {villes.map((ville) => {
          // Map to ProfileCard expected format
          const mappedVille = {
            id: ville.id,
            name: ville.name,
            logo_url: undefined,
            chalandise: ville.chalandise,
            address: ville.address?.formatted_address,
            sectors: [],
          };

          return (
            <ProfileCard
              key={ville.id}
              entity={mappedVille}
              entityType="villes"
              onClick={() => setSelectedVille(ville)}
              onDetailClick={() => setSelectedVille(ville)}
            />
          );
        })}
      </div>

      {selectedVille && (
        <VilleDrawer ville={selectedVille} onClose={() => setSelectedVille(null)} />
      )}
    </div>
  );
};
